/**
 * Features Banner Component
 *
 * Displays a button to show all current features of the form.
 */
/* eslint-disable react/jsx-no-bind, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */

import { useState } from 'preact/hooks';
import { MOCK_MODE_ENABLED } from '@ox/visits-ui/config/mockMode';

export function FeaturesBanner() {
  const [showMenu, setShowMenu] = useState(false);
  
  // Don't render if mock mode is disabled
  if (!MOCK_MODE_ENABLED) {
    return null;
  }

  const handleToggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <>
      {/* Banner - Bottom Left */}
      <div className="features-banner" onClick={handleToggleMenu} title="Click to view form features">
        <span className="features-emoji">✨</span>
        FEATURES
        <span className="features-arrow">{showMenu ? '▼' : '▲'}</span>
      </div>

      {/* Dropdown Menu - Opens Upward */}
      {showMenu && (
        <>
          {/* Backdrop to close menu */}
          <div className="features-backdrop" onClick={() => setShowMenu(false)} />

          {/* Menu */}
          <div className="features-menu">
            {/* Header */}
            <div className="features-menu-header">
              <div className="features-menu-title">✨ Form Features</div>
            </div>

            {/* Features List */}
            <div className="features-list">
              <div className="feature-item">
                <div className="feature-title">🎯 Smart Navigation</div>
                <div className="feature-description">
                  Conditional sections that appear/disappear based on your answers. Progress bar
                  dynamically adjusts.
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-title">💾 Auto-Save</div>
                <div className="feature-description">
                  Your progress is automatically saved as you fill out the form. Never lose your
                  work!
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-title">✅ Field Validation</div>
                <div className="feature-description">
                  Required fields are validated before you can continue to the next section.
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-title">📷 Smart Image Compression</div>
                <div className="feature-description">
                  Client-side image compression saves space and speeds up uploads without quality
                  loss.
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-title">📱 Mobile Optimized</div>
                <div className="feature-description">
                  Fully responsive design that works seamlessly on mobile, tablet, and desktop.
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-title">🎨 Blox Design System</div>
                <div className="feature-description">
                  Built with Opendoor's Blox design system for consistent, professional UI/UX.
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-title">📂 localStorage Persistence</div>
                <div className="feature-description">
                  Draft data persists in localStorage in mock mode, survives page refreshes.
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
